import { Typography } from '@stern-ui/ui';

import accessCmdLogo from '@/assets/logos/access-cmd.svg';
import { WelcomeContentProps } from '@/types';

export const AccessCMD = (props: WelcomeContentProps) => {
	const { hciName } = props;
	const liClass =
		'bg-[url(/src/assets/icons/check.svg)] bg-no-repeat pl-8 mb-4 [background-position:center_left]';
	return (
		<>
			<img src={accessCmdLogo} alt='AccessCMD' className='w-[148px] mb-8' />
			<Typography variant='main' className='text-secondaryTextDark pb-8'>
				Thank you for your interest in AccessCMD
			</Typography>
			<Typography variant='bodyBig'>
				{hciName} and Cohort Science would like to offer you the opportunity to participate
				in AccessCMD, a research study that collects health information directly from
				patients with Cardiometabolic Disease (CMD).
			</Typography>
			<ul className='my-8'>
				<li className={liClass}>
					Participation in AccessCMD can be done entirely from your home via the use of a
					smartphone, tablet or computer.
				</li>
				<li className={liClass}>
					Participation does not require you to visit your healthcare provider, hospital
					or clinic.
				</li>
				<li className={liClass}>
					Studies like this help improve our understanding and progression of CMD.
				</li>
				<li className={liClass}>
					Studies like this are crucial to the development of better treatments for CMD.
				</li>
			</ul>
			<Typography variant='bodyBig'>
				For further information, please visit the{' '}
				<a href='https://www.accesscmd.org/' target='_blank' rel='noreferrer'>
					AccessCMD website
				</a>
				.
			</Typography>
		</>
	);
};
